export const COMMUNITY_VOICES = 'communityVoice';
export const FAVOURITE_VOICES = 'favouriteVoice';
export const VBEE_VOICES = 'vbeeVoice';
export const MY_VOICES = 'myVoice';

export const VOICE_ITEM_VARIANT = {
  CARD: 'CARD',
  LIST: 'LIST',
};

export const COMMUNITY_SECTION = {
  FEATURED_VOICE: 'featuredVoice',
  TRENDING_VOICE: 'trendingVoice',
  NEWEST_VOICE: 'newestVoice',
};

export const VOICE_SCOPE = {
  FEATURED: 'featured',
};

export const COMMUNITY_SORT_TYPE = {
  TRENDING_30_DAYS: 'stats30d.totalCredits_desc',
  TOTAL_CREDITS_DESC: 'stats.totalCredits_desc',
  PUBLISH_AT_DESC: 'publishAt_desc',
};

export const VOICE_SELECTION_TABS = [
  { label: VBEE_VOICES, name: VBEE_VOICES },
  { label: COMMUNITY_VOICES, name: COMMUNITY_VOICES },
  { label: MY_VOICES, name: MY_VOICES },
  { label: FAVOURITE_VOICES, name: FAVOURITE_VOICES },
];

export const FAVOURITE_VOICES_ACTION = {
  ADD: 'add',
  REMOVE: 'remove',
};

export const TRENDING_VOICE_CREDITS = 30000000;

export const FAVOURITE_VOICES_LIMIT = 50;
export const VOICE_HIGHTLIGHT_WEEK_PAGINATION_LIMIT = 20;
